(() => {
  if (customElements.get('story-slider')) {
    return;
  }

  class StorySlider extends customElements.get(
    'slider-component'
  ) {
    constructor() {
      super();
      this.options = {
        ...this.options,
        ...{
          slidesPerView: 'auto',
          spaceBetween: 58,
          watchSlidesProgress: true
        }
      };
    }
  }

  customElements.define('story-slider', StorySlider);
})();
